/** الترجمة العربية — نفس بنية المفاتيح المسطحة كـ en.ts */
const ar = {
  unique_death_history: "سجل القتل",
  reg_events: "الفعاليات",
  reg_details: "الوصف والمكافآت",
  reg_details_pending: "سيتم الإعلان عن التفاصيل قريبًا.",
  reg_open: "مفتوح",
  reg_closed: "مغلق",
  reg_joined: "مسجل",
  reg_equalized: "متكافئ",
  reg_standard: "عادي",
  reg_cancel_registration: "إلغاء التسجيل",
  reg_joined_hint: "أنت مسجل في هذه الفعالية.",
  reg_open_hint: "التسجيل مفتوح. سجل للمشاركة.",
  reg_closed_hint: "التسجيل مغلق.",
  reg_translating: "جارٍ الترجمة…",
  reg_translation_error: "الترجمة غير متاحة. يتم عرض النص الأصلي.",
  reg_retry: "إعادة المحاولة",

  battle_pass: 'بطاقة المعركة',
  menu_main: 'القائمة الرئيسية',
  menu_tools: 'الأدوات',
  menu_open: 'فتح القائمة',
  menu_close: 'إغلاق القائمة',
  menu_home: 'العودة للرئيسية',
  guide: 'دليل',
  daily_login: 'تسجيل الدخول اليومي',
  spin_title: 'العجلة',
  special_offer: 'عرض خاص',
  auction_system: 'دار المزاد',
  title_manager: 'التخصيص',
  ranking: 'التصنيف',
  unique: 'يونيك',
  job_system: 'نظام الوظائف',
  vip_system: 'VIP',
  donation: 'تبرع',
  surveys: 'الاستطلاعات',
  settings: 'الإعدادات',
  messages: 'الرسائل',
  unique_status_title: 'الحالة الحالية',
  unique_logs_title: 'سجل التاريخ',
  unique_table_name: 'Unique',
  unique_table_character: 'الشخصية',
  unique_table_status: 'الحالة',
  unique_table_event: 'الحدث',
  unique_table_map: 'الخريطة',
  unique_table_time: 'الوقت',
  unique_status_alive: 'حي',
  unique_status_dead: 'ميت',
  unique_event_spawn: 'ظهر',
  unique_event_death: 'قُتل',
  unique_refresh: 'تحديث',
  unique_sort_alive_first: 'ترتيب: الأحياء أولاً',
  unique_sort_dead_first: 'ترتيب: الأموات أولاً',
  unique_deaths_tooltip_title: 'آخر 5 عمليات قتل',
  unique_deaths_empty: 'لا توجد عمليات قتل مسجلة',
  unique_load_error: 'تعذر تحميل سجل Unique.',
  unique_no_data: 'لم يتم العثور على بيانات.',
  unique_logs_empty: 'لا توجد أحداث في السجل بعد.',
  schedule: 'الجدول',
  sched_no_events: 'لا توجد أحداث مجدولة.',
  sched_running: 'قيد التشغيل',
  sched_load_error: 'تعذر تحميل الجدول. حاول مرة أخرى لاحقاً.',
  reg_register: 'تسجيل',
  reg_remove_register: 'إزالة التسجيل',
  reg_processing: 'جاري المعالجة...',
  reg_registered_success: 'لقد سجلت في الحدث بنجاح',
  reg_unregistered_success: 'لقد ألغيت تسجيلك من الحدث بنجاح',
  reg_no_events: 'لا توجد أحداث متاحة.',
  reg_load_error: 'تعذر تحميل الأحداث. حاول مرة أخرى لاحقاً.',
  reg_error_invalid_event: 'حدث غير صالح',
  reg_error_not_logged_in: 'يجب تسجيل الدخول لتسجيل الأحداث',
  reg_error_not_available: 'الحدث غير متاح للتسجيل',
  reg_error_already_registered: 'خطأ في التسجيل في الحدث. قد تكون مسجلاً بالفعل.',
  reg_error_unregister: 'خطأ في إلغاء التسجيل من الحدث',
  reg_error_processing: 'خطأ في معالجة الطلب',
  reg_error_connection: 'خطأ في الاتصال. يرجى المحاولة مرة أخرى.',
  reg_modal_title: 'Equalized System',
  reg_weapons: 'الأسلحة (اختر 1)',
  reg_buffs: 'التعزيزات (اختر 1)',
  reg_essence: 'Essence (نشط دائماً)',
  reg_force: 'Force (نشط دائماً)',
  reg_btn_register: 'تسجيل',
  reg_btn_cancel: 'إلغاء',
  register: 'تسجيل',
  r_ia: 'R-AI',
  chat_welcome_message: 'مرحباً! 👋 أنا <strong>R-AI</strong>، مساعدك الذكي لـ Silkroad Origins.',
  chat_welcome_question: 'كيف يمكنني مساعدتك اليوم؟',
  chat_input_placeholder: 'اكتب رسالتك...',
  chat_send_button: 'إرسال',
  chat_send_title: 'إرسال الرسالة',
  chat_char_count: '{current} / {max}',
  chat_load_error: 'تعذر تحميل سجل المحادثة. حاول مرة أخرى لاحقاً.',
  chat_error_connection: 'خطأ في الاتصال. يرجى المحاولة مرة أخرى.',
  drop_log: 'سجل القطاف',
  log_table_item: 'العنصر',
  log_table_character: 'الشخصية',
  log_table_monster: 'الوحش',
  log_table_map: 'الخريطة',
  log_table_date: 'التاريخ',
  log_table_ago: 'منذ',
  log_search_placeholder: 'بحث...',
  log_time_seconds: 'ث',
  log_time_minutes: 'د',
  log_time_hours: 'س',
  log_time_days: 'يوم',
  log_filter_race: 'العرق',
  log_filter_race_chinese: 'Chinese',
  log_filter_race_euro: 'أوروبي',
  log_filter_type: 'النوع',
  log_filter_time_all: 'الكل',
  log_filter_time_today: 'اليوم',
  log_filter_time_week: 'هذا الأسبوع',
  log_filter_time_month: 'هذا الشهر',
  log_filter_apply: 'تطبيق',
  log_filter_reset: 'إعادة تعيين',
  log_load_error: 'تعذر تحميل سجل القطاف. حاول مرة أخرى لاحقاً.',
  log_no_results: 'لا توجد قطافات تطابق الفلاتر.',
  log_modal_i_need_it: 'أريده',
  log_modal_sending: 'جاري الإرسال...',
  log_modal_sent: 'تم الإرسال',
  log_modal_error: 'خطأ',
  log_modal_connection_error: 'خطأ في الاتصال',
  log_modal_message_template: 'مرحباً، أنا مهتم بـ {item} الذي قطفته. كم تطلب؟',
  log_chat_button_title: 'التواصل عبر الدردشة',
  log_chat_self_error: 'لا يمكنك إرسال رسائل لنفسك',
  languages: 'اللغات',
  server_time: 'وقت الخادم',
  loading_data: 'جاري تحميل البيانات...',
  auth_loading: 'جاري المصادقة...',
  auth_error: 'تعذرت المصادقة. أعد الفتح من اللعبة.',
  bp_duration: 'المدة: {start} - {end} ({remaining} متبقي)',
  bp_level: 'المستوى',
  bp_buy_pass: 'شراء البطاقة',
  bp_premium_active: 'البطاقة المميزة نشطة',
  bp_premium_reward: 'مكافأة مميزة',
  bp_max_level: 'الحد الأقصى للمستوى: {level}',
  bp_no_active: 'لا توجد بطاقة معركة نشطة',
  bp_reward_success: 'تم استلام المكافأة بنجاح!',
  bp_claim_error: 'تعذر استلام المكافأة. حاول مرة أخرى لاحقاً.',
  bp_exp_info_title: 'تجربة بطاقة المعركة',
  bp_exp_tower_defense_victory: 'دفاع البرج: النصر: 45 نقطة | الهزيمة: 5 نقاط',
  bp_exp_hell_prison_victory: 'سجن الجحيم: النصر: 50 نقطة | الهزيمة: 10 نقاط',
  bp_exp_witch_hunt_victory: 'مطاردة الساحرات: النصر: 50 نقطة | الهزيمة: 10 نقاط',
  bp_exp_survival: 'البقاء: المركز الأول: 30 نقطة | المركز الثاني: 15 نقطة | المركز الثالث: 5 نقاط',
  bp_exp_last_man_standing: 'آخر رجل واقف: النصر: 95 نقطة',
  bp_exp_madness: 'الجنون: المركز الأول: 30 نقطة | المركز الثاني: 15 نقطة | المركز الثالث: 5 نقاط',
  bp_exp_garden_job_victory: 'الحديقة (العمل): النصر: 50 نقطة | الهزيمة: 10 نقاط',
  bp_exp_capture_flag_victory: 'القبض على العلم: النصر: 50 نقطة | الهزيمة: 10 نقاط',
  bp_exp_battle_arena_victory: 'ساحة المعركة: النصر: 50 نقطة | الهزيمة: 10 نقاط',
  bp_exp_league_map_victory: 'خريطة الدوري: النصر: 55 نقطة | الهزيمة: 10 نقاط',
  bp_exp_medusa_victory: 'Medusa: النصر: 100 نقطة | الهزيمة: 20 نقطة',
  bp_exp_roc_victory: 'Roc: النصر: 100 نقطة | الهزيمة: 20 نقطة',
  bp_exp_normal_uniques_victory: 'Unique عادي: النصر: 5 نقاط | الهزيمة: 3 نقاط',
  bp_exp_arabian_uniques_victory: 'Unique عربي: النصر: 7 نقاط | الهزيمة: 5 نقاط',
  bp_exp_legendary_uniques_victory: 'Unique أسطوري: النصر: 10 نقاط | الهزيمة: 7 نقاط',
  bp_exp_job_kills: 'قتل الوظيفة: نقطتان لكل قتل',
  bp_exp_job_delivery: 'تسليم الوظيفة: 15 نقطة لكل تسليم',
  bp_exp_global_chat: 'استخدام الدردشة العامة: نقطتان لكل استخدام',
  bp_exp_summary:
    'اكسب نقاط XP من الأحداث: دفاع البرج، سجن الجحيم، مطاردة الساحرات، البقاء، الجنون، حديقة العمل، القبض على العلم، ساحة المعركة، خريطة الدوري، Medusa، Roc، Unique، قتل/تسليم الوظيفة، والدردشة العامة.',
  silk_confirm_cost: 'التكلفة: {amount} Silk',
  silk_confirm_balance: 'رصيدك: {amount} Silk',
  silk_confirm_after: 'الرصيد بعد الشراء: {amount} Silk',
  silk_confirm_not_enough: 'ليس لديك Silk كافٍ لهذا الشراء.',
  silk_confirm_cancel: 'إلغاء',
  silk_confirm_confirm: 'تأكيد',
  bp_premium_confirm_title: 'شراء البطاقة المميزة',
  bp_premium_confirm_msg: 'افتح جميع المكافآت المميزة لهذا الموسم.',
  bp_levelup_confirm_title: 'ترقية المستوى',
  bp_levelup_confirm_msg: 'احصل فوراً على مستوى Battle Pass إضافي.',
  silk_confirm_price_label: 'السعر',
  silk_confirm_your_silk: 'Silk الخاص بك',
  silk_confirm_checking: 'جاري التحقق...',
  silk_confirm_unavailable: 'غير متاح',
  silk_confirm_retry_later: 'أعد المحاولة لاحقاً',
  silk_confirm_not_enough_short: 'Silk غير كافٍ',
  silk_confirm_processing: 'جاري المعالجة',
  silk_confirm_processing_msg: 'جاري معالجة عملية الشراء...',
  silk_confirm_success: 'نجاح',
  silk_confirm_failed: 'فشل',
  silk_confirm_wait: 'يرجى الانتظار',
  silk_confirm_close: 'إغلاق',
  cal_schedule_label: 'جدول تسجيل الدخول: {start} - {end}',
  cal_remaining_label: '({remaining} متبقي)',
  cal_checked_in_status: 'تم تسجيل الدخول {checked} من أصل {total} يوم (فاتك {missed} يوم)',
  cal_day_label: 'اليوم {day}',
  cal_checkin_available: 'يمكنك تسجيل الدخول الآن!',
  cal_next_checkin: 'تسجيل الدخول التالي في: {hours}س {minutes}د',
  cal_claim_error: 'تعذر إتمام الإجراء. حاول مرة أخرى لاحقاً.',
  cal_no_campaign: 'لا توجد حملة نشطة',
  spin_daily_spins: '{max} تدوير يومي ({used}/{max})',
  spin_recent_rewards: 'آخر 5 مكافآت',
  spin_congratulations: 'تهانينا!',
  spin_probability: 'الاحتمالية:',
  spin_daily_reached_tooltip: 'تم الوصول للحد اليومي. للاستخدام مجدداً، اشترِ بـ Silk.',
  spin_reset_confirm_title: 'تأكيد إعادة التعيين',
  spin_reset_confirm_message: 'هل أنت متأكد من رغبتك في إعادة تعيين التدوير؟',
  spin_reset_confirm_silk: '{amount} silk',
  spin_reset_confirm_cancel: 'إلغاء',
  spin_reset_confirm_confirm: 'تأكيد',
  spin_reset_success: 'تم إعادة تعيين التدوير بنجاح!',
  spin_reset_error: 'تعذر إعادة تعيين التدوير.',
  spin_error_spin: 'تعذر تدوير العجلة.',
  spin_error_winner: 'لم يتم العثور على العنصر الفائز.',
  spin_error_connection: 'خطأ في الاتصال بالخادم.',
  so_title: 'عرض خاص',
  so_recommended: 'موصى به',
  so_offer_ends_in: 'ينتهي العرض في',
  so_buy: 'شراء',
  so_available: 'متاح',
  so_sold_out: 'نفذت الكمية',
  so_processing: 'جاري المعالجة...',
  so_purchase_success: 'تم الشراء بنجاح!',
  so_purchase_error: 'خطأ في الشراء',
  so_network_error: 'خطأ في الشبكة',
  so_confirm_title: 'تأكيد الشراء',
  so_confirm_message: 'هل تريد شراء {name}؟',
  so_no_offers: 'لا توجد عروض نشطة',
  auc_time_left: 'الوقت المتبقي',
  auc_bid_concluded: 'انتهى المزاد',
  auc_winner: 'الفائز',
  auc_auction_starting_soon: 'المزاد سيبدأ قريباً',
  auc_enter_bid: 'أدخل مزايدتك',
  auc_bid_now: 'زايد الآن',
  auc_be_first_to_bid: 'كن أول من يزايد',
  auc_current_bid: 'المزايدة الحالية',
  auc_by: 'بواسطة',
  auc_latest_bids: 'آخر المزايدات',
  auc_auction_ended: 'انتهى المزاد. تهانينا للفائز!',
  auc_wait_next_auction: 'يرجى الانتظار حتى يبدأ المزاد التالي.',
  auc_item_rewards: 'مكافآت العناصر',
  auc_no_rewards: 'لا توجد مكافآت متاحة',
  auc_bid_success: 'تم تقديم المزايدة بنجاح!',
  auc_bid_error: 'خطأ في تقديم المزايدة.',
  auc_invalid_bid: 'أدخل مبلغ مزايدة صالح.',
  tm_tab_name: "Name",
  tm_name_colors: "ألوان الاسم المحفوظة",
  tm_name_apply: "تطبيق اللون",
  tm_name_select: "اختر لونًا",
  tm_name_empty: "لا توجد ألوان محفوظة.",
  tm_name_reuse: "سعر كل لون 999 Silks. يمكن إعادة استخدام الألوان المشتراة مجانًا. انتظر 30 ثانية بين التغييرات.",
  tm_name_buy: "شراء لون الاسم",
  tm_name_purchased: "تم شراء لون الاسم.",
  tm_name_applied: "تم تطبيق لون الاسم.",
  tm_name_owned: "تملكه بالفعل",
  tm_name_error: "تعذرت معالجة اللون.",
  tm_cooldown: "انتظر {seconds} ثانية قبل تغيير آخر.",
  tm_tab_title: 'العنوان',
  tm_tab_icon: 'الأيقونة',
  tm_tab_tag: 'العلامة',
  tm_title_column: 'العنوان',
  tm_tag_column: 'العلامة',
  tm_actions_column: 'الإجراءات',
  tm_enter_title: 'أدخل نص العنوان...',
  tm_enter_tag: 'أدخل نص العلامة...',
  tm_test: 'اختبار',
  tm_edit: 'تعديل',
  tm_edit_title_modal_title: 'تعديل العنوان',
  tm_price_edit: 'سعر التعديل',
  tm_error_editing_title: 'خطأ في تعديل العنوان.',
  tm_title_edited: 'تم تحديث العنوان بنجاح.',
  tm_buy: 'شراء',
  tm_total_pay: 'المبلغ الإجمالي',
  tm_color_optional: 'لون مخصص (اختياري)',
  tm_edit_separate: 'تعديل لقب موجود (منفصل)',
  tm_price_title: 'سعر العنوان',
  tm_price_color: 'سعر اللون',
  tm_price_tag: 'سعر العلامة',
  tm_price_icon_label: '{amount} Silk',
  tm_apply_title: 'تطبيق العنوان',
  tm_remove_title: 'إزالة العنوان',
  tm_apply_tag: 'تطبيق العلامة',
  tm_remove_tag: 'إزالة العلامة',
  tm_no_titles: 'لا توجد عناوين محفوظة.',
  tm_no_tags: 'لا توجد علامات محفوظة.',
  tm_no_icons: 'لم يتم العثور على أيقونات.',
  tm_icon_search: 'بحث عن أيقونات...',
  tm_icon_left: 'الأيقونة اليسرى',
  tm_icon_right: 'الأيقونة اليمنى',
  tm_buy_title_modal_title: 'تأكيد شراء العنوان',
  tm_buy_tag_modal_title: 'تأكيد شراء العلامة',
  tm_buy_icon_modal_title: 'تأكيد شراء الأيقونة',
  tm_buy_title_label: 'العنوان:',
  tm_buy_tag_label: 'العلامة:',
  tm_buy_icon_label: 'الأيقونة:',
  tm_buy_price_label: 'السعر:',
  tm_buy_balance_label: 'رصيدك:',
  tm_buy_includes: 'يشمل:',
  tm_buy_includes_title_color: 'العنوان + لون مخصص',
  tm_buy_not_enough: '⚠ ليس لديك Silk كافٍ.',
  tm_buy_needs_more: 'تحتاج إلى {amount} Silk إضافي.',
  tm_buy_confirm: 'تأكيد الشراء',
  tm_buy_cancel: 'إلغاء',
  tm_error_testing_title: 'خطأ في اختبار العنوان.',
  tm_error_buying_title: 'خطأ في شراء العنوان.',
  tm_error_buying_tag: 'خطأ في شراء العلامة.',
  tm_error_buying_icon: 'خطأ في شراء الأيقونة.',
  tm_error_applying_icon: 'خطأ في تطبيق الأيقونة.',
  tm_error_getting_balance: 'خطأ في الحصول على رصيد Silk.',
  tm_error_applying_title: 'خطأ في تطبيق العنوان.',
  tm_error_applying_tag: 'خطأ في تطبيق العلامة.',
  tm_error_removing_title: 'خطأ في إزالة العنوان.',
  tm_error_removing_tag: 'خطأ في إزالة العلامة.',
  tm_processing: 'جاري المعالجة...',
  tm_already_have_title: 'لديك هذا العنوان بالفعل.',
  tm_already_have_tag: 'لديك هذه العلامة بالفعل.',
  tm_already_have_icon: 'لديك هذه الأيقونة بالفعل.',
  tm_not_enough_silk: 'Silk غير كافٍ.',
  tm_title_applied: 'تم تطبيق العنوان بنجاح.',
  tm_title_purchased: 'تم شراء العنوان! استمتع بعنوانك الجديد.',
  tm_tag_applied: 'تم تطبيق العلامة بنجاح.',
  tm_icon_applied: 'تم تطبيق الأيقونة بنجاح.',
  tm_title_removed: 'تم إلغاء تفعيل العنوان بنجاح.',
  tm_tag_removed: 'تم إزالة العلامة بنجاح.',
  tm_icon_purchased: 'تم شراء الأيقونة بنجاح.',
  tm_test_applied: 'تم تطبيق معاينة العنوان (مؤقت).',
  ranking_search_placeholder: 'ابحث عن لاعب...',
  ranking_filter_race: 'العرق',
  ranking_race_chinese: 'Chinese',
  ranking_race_euro: 'Euro',
  ranking_filter_mastery: 'الإتقان',
  ranking_mastery_bicheon: 'Bicheon',
  ranking_mastery_pacheon: 'Pacheon',
  ranking_mastery_heuksal: 'Heuksal',
  ranking_mastery_warrior: 'محارب',
  ranking_mastery_rogue: 'لص',
  ranking_mastery_wizard: 'ساحر',
  ranking_filter_reset: 'إعادة تعيين',
  ranking_filter_refresh: 'تحديث التصنيف',
  ranking_col_character: 'الشخصية',
  ranking_col_guild: 'اسم النقابة',
  ranking_col_points: 'النقاط',
  ranking_no_results: 'لا يوجد لاعبون يطابقون الفلاتر.',
  ranking_empty: 'بيانات التصنيف غير متاحة بعد. حاول مرة أخرى لاحقاً.',
  ranking_error: 'تعذر تحميل التصنيف. انقر ↺ لإعادة المحاولة.',
  ranking_error_auth: 'تعذر تحميل التصنيف. انقر ↺ لإعادة المحاولة.',
  ranking_player_title: 'تصنيف اللاعبين',
  ranking_guild_title: 'تصنيف النقابات',
  ranking_mastery_title: 'تصنيف الإتقان',
  ranking_arena_title: 'تصنيف ساحة PVP',
  ranking_profile_loading: 'جاري تحميل ملف الشخصية...',
  ranking_profile_error_title: 'خطأ',
  ranking_profile_error_message: 'تعذر تحميل ملف الشخصية.',
  ranking_profile_back: 'العودة إلى التصنيف',
  ranking_profile_inventory: 'المخزون',
  ranking_profile_avatar: 'الصورة الرمزية',
  ranking_profile_level: 'مس.',
  ranking_profile_strength: 'القوة:',
  ranking_profile_intelligence: 'الذكاء:',
  ranking_profile_guild: 'النقابة:',
  ranking_profile_no_guild: '<لا يوجد>',
  job_level: 'المستوى',
  job_daily_progress: 'تقدم العمل اليومي',
  job_claimed: 'تم المطالبة',
  job_completed: 'مكتمل',
  job_in_progress: 'قيد التنفيذ',
  job_gold: 'ذهب',
  job_min: 'دقيقة',
  job_delivery_history: 'سجل توصيلات اليوم',
  job_route: 'المسار',
  job_gold_earned: 'الذهب المكتسب',
  job_delivery_time: 'وقت التوصيل',
  job_delivery_hour: 'ساعة التوصيل',
  job_no_deliveries_today: 'لا توجد توصيلات مسجلة اليوم.',
  job_no_job_info: 'لا توجد معلومات وظيفة متاحة لشخصيتك.',
  job_login_required: 'يجب عليك تسجيل الدخول لعرض تقدم وظيفتك.',
  job_hwid_error: 'تعذر استرداد معلومات الأجهزة.',
  job_level_error: 'تعذر استرداد مستوى الوظيفة.',
  job_no_configuration: 'لا توجد إعدادات متاحة لهذا النوع من الوظائف.',
  job_merchant: 'تاجر',
  job_thief: 'لص',
  job_hunter: 'صياد',
  job_unknown: 'غير معروف',
  job_invalid_data: 'بيانات غير صالحة',
  job_already_claimed_today: 'لقد طالبت بمكافأة اليوم بالفعل.',
  job_complete_progress_first: 'يجب عليك إكمال التقدم اليومي قبل المطالبة بالمكافأة.',
  job_no_reward_for_level: 'لا توجد مكافأة متاحة لمستواك الحالي.',
  job_reward_claimed_success: 'تم المطالبة بالمكافأة بنجاح.',
  job_success: 'نجاح',
  job_error: 'خطأ',
  job_network_error: 'خطأ في الشبكة',
  job_protected_cargo: 'بضاعة تاجر محمية',
  job_stolen_cargo: 'بضاعة تاجر مسروقة',
  cupon_title: 'القسائم',
  cupon_level_required: 'المستوى',
  cupon_rewards_title: 'مكافآت القسيمة',
  cupon_expires_in: 'تنتهي في',
  cupon_claim_button: 'استلام القسيمة',
  cupon_claimed_button: 'تم الاستلام',
  cupon_confirm_button: 'تأكيد',
  cupon_resend_button: 'إعادة إرسال الرمز',
  cupon_verification_title: 'أدخل رمز التحقق',
  cupon_choose_channel: 'Where should we send your code?',
  cupon_contact_missing: 'Not configured',
  cupon_whatsapp_verify: 'Verified number required',
  cupon_configure_contact: 'Configure WhatsApp in Settings',
  cupon_sent_via: 'Code sent via {channel}',
  cupon_code_sent_info: 'سيتم إرسال رمز تحقق إلى بريدك الإلكتروني',
  cupon_code_sent_button: 'تم الإرسال - تحقق من بريدك',
  cupon_coupon_claimed: 'تم استلام القسيمة بنجاح! تحقق من صندوقك في اللعبة.',
  cupon_no_coupons: 'لا توجد قسائم متاحة في الوقت الحالي',
  cupon_already_claimed: 'لقد استلمت هذه القسيمة بالفعل',
  cupon_request_error: 'خطأ في طلب الرمز. حاول مرة أخرى.',
  cupon_complete_code: 'يجب إدخال الرمز المكون من 6 أرقام كاملاً',
  cupon_processing_error: 'خطأ في معالجة الطلب. حاول مرة أخرى.',
  cupon_sending: 'جاري الإرسال...',
  cupon_processing: 'جاري المعالجة...',
  settings_tab_general: 'عام',
  settings_tab_notifications: 'الإشعارات',
  settings_tab_restrictions: 'القيود',
  settings_label_language: 'اللغة',
  settings_label_timezone: 'المنطقة الزمنية',
  settings_label_country: 'البلد',
  settings_label_whatsapp: 'واتساب',
  settings_btn_verify: 'التحقق',
  settings_btn_confirm: 'تأكيد',
  settings_btn_save: 'حفظ',
  settings_btn_validate_now: 'التحقق الآن',
  settings_btn_validate_whatsapp: 'التحقق عبر WhatsApp',
  settings_btn_validate_authenticator: 'التحقق عبر المصادق',
  settings_placeholder_code: 'الرمز',
  settings_placeholder_phone: '1234567890',
  settings_no_events: 'لا توجد أحداث مُعدة',
  settings_minutes_before: 'دقيقة قبل',
  settings_time_remaining: 'الوقت المتبقي حتى التحقق المطلوب التالي',
  settings_validation_warning: 'سينتهي التحقق قريباً. جدد الآن للمتابعة دون انقطاع.',
  settings_validation_active: 'اتصالك مُتحقق منه ونشط.',
  settings_validation_expired: 'يجب التحقق من اتصالك للتمكن من الحركة في اللعبة.',
  settings_coming_soon: '(قريباً)',
  settings_no_hwid: 'تعذر الحصول على HWID. يرجى تسجيل الدخول إلى اللعبة.',
  settings_code_sent: 'تم إرسال الرمز. تحقق من WhatsApp.',
  settings_whatsapp_verified_success: 'تم التحقق من واتساب بنجاح',
  settings_error_update_config: 'خطأ في تحديث الإعدادات',
  settings_error_phone_required: 'يرجى إدخال رقم هاتف',
  settings_error_code_required: 'يرجى إدخال رمز صحيح مكون من 6 أرقام',
  settings_error_send_code: 'خطأ في إرسال رمز التحقق',
  settings_error_verify_code: 'خطأ في التحقق من الرمز',
  settings_error_validate_connection: 'خطأ في التحقق من الاتصال',
  settings_error_code_incorrect: 'رمز غير صحيح',
  settings_no_results: 'لم يتم العثور على نتائج',
  settings_searching: 'جاري البحث...',
  messages_page_title: 'الدردشة',
  messages_conversations: 'المحادثات',
  messages_new_chat: 'محادثة جديدة',
  messages_search_player: 'ابحث عن لاعب...',
  messages_type_message: 'اكتب رسالة...',
  messages_send: 'إرسال',
  messages_attach_item: 'إرفاق عنصر',
  messages_online: 'متصل',
  messages_offline: 'غير متصل',
  messages_no_messages: 'لا توجد رسائل بعد',
  messages_no_conversations: 'لا توجد محادثات',
  messages_loading: 'جاري التحميل...',
  messages_error_send: 'خطأ في إرسال الرسالة',
  messages_error_load: 'خطأ في تحميل الرسائل',
  messages_retry: 'إعادة المحاولة',
  messages_select_player: 'اختر لاعباً لبدء الدردشة',
  messages_select_item: 'اختر عنصراً',
  messages_item_attached: 'تم إرفاق العنصر',
  messages_remove_item: 'إزالة العنصر',
  messages_confirm: 'تأكيد',
  messages_cancel: 'إلغاء',
  messages_today: 'اليوم',
  messages_yesterday: 'أمس',
  messages_typing: 'يكتب...',
  messages_translate: 'ترجمة',
  messages_show_original: 'عرض الأصل',
  messages_translate_error: 'تعذر ترجمة الرسالة',
  messages_scroll_for_more: 'مرر لأعلى لعرض الرسائل القديمة',

  notifications_title: 'الإشعارات',
  notifications_no_notifications: 'لا توجد إشعارات متاحة',
  notifications_no_type: 'لا يوجد نوع',
  notifications_published: 'تم النشر:',
  notifications_expires: 'ينتهي:',
  notifications_like: 'إعجاب',
  notifications_dislike: 'عدم إعجاب',
  notifications_back_to_notifications: 'العودة إلى الإشعارات',
  notifications_vote_error: 'خطأ في تحديث التصويت',
  notifications_loading: 'جاري التحميل...',
  notifications_error_load: 'خطأ في تحميل الإشعارات',
  notifications_not_found: 'الإشعار غير موجود أو غير متاح',

  dt_title: 'المهام اليومية',
  dt_global_progress: 'التقدم العام',
  dt_tasks_completed: 'مهام مكتملة',
  dt_no_tasks: 'لا توجد مهام متاحة في الوقت الحالي.',
  dt_claimed: 'تم المطالبة',
  dt_incomplete: 'غير مكتمل',
  dt_final_rewards: 'المكافآت النهائية',
  dt_final_rewards_description:
    'أكمل جميع المهام اليومية واطلب جميع مكافآتها لفتح هذه المكافآت النهائية.',
  dt_claim_final_reward: 'المطالبة بالمكافأة النهائية',
  dt_complete_all_first: 'يجب عليك إكمال والمطالبة بجميع المهام اليومية أولاً',
  dt_success: 'نجاح',
  dt_error: 'خطأ',
  dt_network_error: 'خطأ في الشبكة',
  dt_processing: 'جاري المعالجة...',
  dt_login_required: 'يجب تسجيل الدخول لعرض المهام اليومية.',
  dt_load_error: 'تعذر تحميل المهام اليومية.',

  don_package: 'الباقة:',
  don_silks: 'سيلكس:',
  don_price: 'السعر:',
  don_silks_label: 'سيلكس',
  don_vip_points: '{amount} نقاط VIP',
  don_promo: 'عرض',
  don_special_offer: 'عرض خاص',
  don_back: '← رجوع',
  don_pay: 'ادفع $',
  don_continue_paypal: 'المتابعة إلى PayPal',
  don_processing: 'جاري المعالجة...',
  don_binance_soon: 'دفع Binance قريبًا...',
  don_error_create: 'خطأ في إنشاء الدفع',
  don_stripe_not_loaded: 'لم يتم تحميل Stripe SDK',
  don_success_processing: 'جاري معالجة الدفع...',
  don_success_wait: 'يرجى الانتظار أثناء تأكيد تبرعك.',
  don_success_ok: 'تم الدفع بنجاح!',
  don_success_fail: 'لم يكتمل الدفع',
  don_success_fail_msg: 'تعذر تأكيد تبرعك. يرجى المحاولة مرة أخرى.',
  don_cancel_title: 'تم إلغاء الدفع',
  don_cancel_msg: 'لم يكتمل تبرعك. يمكنك المحاولة في أي وقت.',
  don_back_to: 'العودة إلى التبرعات',
  don_credited: 'تم إضافة {amount} سيلكس إلى حسابك.',
  cal_claimed: 'تم الاستلام',
  cal_locked: 'مقفل',
  cal_today: 'اليوم',
  cal_claim: 'استلام',
  cal_streak_label: 'أيام مسجّلة',
  cal_consecutive_login: 'تسجيل متتالٍ',
  cal_upcoming: 'القادمة',
  cal_upcoming_rewards: 'المكافآت القادمة',
  cal_no_upcoming: 'لا يوجد',
  cal_monthly_bonus: 'مكافأة شهرية',
  cal_monthly_bonus_desc: 'سجّل الدخول لمدة {days} يومًا للمطالبة بالمكافأة الشهرية.',
  cal_days_remaining: '{days} أيام متبقية',
  cal_day_remaining: 'يوم واحد متبقٍ',
  cal_info_title: 'معلومات الحدث',
  cal_default_desc: 'سجّل الدخول كل يوم للمطالبة بمكافآت حصرية. فاتك يوم؟ واصل التقدم، الإمبراطورية بانتظارك.',
  cal_prev: 'السابق',
  cal_next: 'التالي',
  cal_bonus_days_unit: 'أيام',
  cal_bonus_n_day: 'يوم واحد',
  cal_bonus_n_days: '{days} أيام',
  cal_bonus_7_days: '7 أيام',
  cal_bonus_15_days: '15 أيام',
  cal_bonus_1_month: 'شهر',
  bp_multiple_items: 'عدة عناصر متاحة',
  vip_title: 'نظام VIP',
  vip_col_level: 'المستوى',
  vip_col_progress: 'التقدم',
  vip_col_rewards: 'المكافآت',
  vip_col_state: 'الحالة',
  vip_level_label: 'مستوى VIP ({level})',
  vip_state_unlocked: 'Unlocked',
  vip_no_levels: 'No VIP levels configured.',
  vip_points_rate: '{points} VIP Points.',
  vip_your_points: 'Your points',
  vip_current_level: 'Current level',
  vip_next_level: 'Next level',
  vip_all_unlocked: 'All levels unlocked',
  vip_points_remaining: '{points} points to go',
  vip_information: 'VIP information',
  vip_close: 'Close',
  vip_info_account: 'VIP points belong to your account. Only completed donations with credited VIP points count.',
  vip_info_unlock: 'Reach the required points to unlock each level. Your points accumulate and are not spent when a level unlocks.',
  vip_info_rewards: 'Unlocked means you meet the requirement. Reward claiming and delivery are not available yet.',
  vip_state_locked: 'مقفل',
  vip_note: 'مقابل كل $1 تتبرع به ستحصل على',
  vip_note_points: '10 نقاط VIP.',
  don_history: "سجل المشتريات",
  don_history_loading: "جارٍ تحميل المشتريات...",
  don_history_error: "تعذر تحميل سجل المشتريات.",
  don_history_empty: "لا توجد مشتريات بعد.",
  don_history_date: "التاريخ",
  don_history_method: "طريقة الدفع",
  don_history_status: "الحالة",
  don_history_previous: "السابق",
  don_history_next: "التالي",
  don_status_completed: "مكتمل",
  don_status_pending: "قيد الانتظار",
  don_status_cancelled: "ملغى",
  don_status_failed: "فشل",
  don_daily_limit: "أنفقت {current} خلال آخر 24 ساعة. ستجعل هذه العملية بقيمة {amount} الإجمالي {total}، متجاوزًا الحد البالغ {limit}. المبلغ المتاح لك هو {remaining}.",
  don_limit_available: "المتاح: {amount}",
  don_reset_ready: "مدفوعات آخر 24 ساعة",
  don_reset_updating: "جارٍ تجديد الحد...",
  don_reset_error: "تعذر تحميل الحد",
  don_reset_in: "يتجدد خلال {time}",
  don_limit_locked: "وصلت إلى حد المدفوعات. انتظر انتهاء العد التنازلي في الأعلى قبل إجراء دفعة أخرى.",
} as const;

export default ar;
